import * as Webfont from 'webfontloader';
export default class WebFont {

    static #fontLoading = [];
    static #timeout = 90000;
    static #fontLoaded = [];

    static async loadFont(font, resolve, reject){
        if(!this.#fontLoaded.includes(font.familyName)){
            let wait = false;
            if(!this.#fontLoading.includes(font.familyName)){
                this.#fontLoading.push(font.familyName);
            }else{
                wait = true;
            }

            if(wait){
                while(this.#fontLoading.includes(font.familyName)){
                    await new Promise(r => setTimeout(r, 100));
                }
            }

            //https://github.com/typekit/webfontloader
            if(await this.#testIfFontFileExist(font)){
                Webfont.load({
                    custom: {
                        families: [font.familyName],
                        urls: ['https://www.murrano.pl/fonts/' + font.familyName + '/stylesheet.css']
                    },
                    timeout: this.#timeout,
                    active: () => {
                        this.#moveToLoadedAndResolve(font.familyName, resolve);
                    },
                    fontactive: (familyName, fvd) => {
                        this.#moveToLoadedAndResolve(font.familyName, resolve);
                    },
                    inactive: () => {
                        this.#moveToLoadedAndResolve(font.familyName, resolve);
                    },
                    fontinactive: (familyName, fvd) => {
                        this.#moveToLoadedAndResolve(font.familyName, resolve);
                    }
                });
            }else{
                this.#moveToLoadedAndResolve(font.familyName, resolve);
            }
        }else{
            resolve();
        }
    }

    static #moveToLoadedAndResolve(familyName, resolve){
        this.#fontLoaded.push(familyName);
        this.#fontLoading = this.#fontLoading.filter(item => item !== familyName);
        resolve();
    }

    static async #testIfFontFileExist(font){
        let response = true;
        await fetch(`https://www.murrano.pl/fonts/${font.familyName}/stylesheet.css`,{
            method: 'GET'
        })
        .then(res => {
            if(res.status != 200){
                response = false;
            }
        })
        .catch(err => {
            response = false;
        });
        return response;
    }
}